import { IContractTemplateResponse } from 'services/templates/contract-template/types';
import {
  IContractTemplateTreeItemForm,
  TEMPLATE_TYPE,
} from 'services/templates/types';
import { connectTemplateTreeItems } from '../templateQueryItemsConnector';

export const contractTemplateQueryToForm = (
  query: IContractTemplateResponse,
  lowestAvailableId?: string
): IContractTemplateTreeItemForm[] => [
  {
    id: '0',
    type: TEMPLATE_TYPE.contract,
    content: query.title,
    children: connectTemplateTreeItems(
      {
        customSections: query.customTemplateSections,
        digitalDistribution: query.digitalDistributionSection ?? undefined,
        physicalDistribution: query.physicalDistributionSection ?? undefined,
        merchDistribution: query.merchDistributionSection ?? undefined,
        channelDistribution: query.channelDistributionSection ?? undefined,
      },
      lowestAvailableId ?? '1'
    ),
    disabledCollapse: true,
    disabledSelection: true,
    disabledRemove: true,
    autoFocus: true,
  },
];
